import { Box, Button, Dialog, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SportsBasketballOutlinedIcon from "@mui/icons-material/SportsBasketballOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import CodeOutlinedIcon from "@mui/icons-material/CodeOutlined";
import { HOOPER_BLUE } from "../../shared/constants";
import type { TourId } from "./types";

const ILLUSTRATION: Record<TourId, typeof CodeOutlinedIcon> = {
  welcome: SportsBasketballOutlinedIcon,
  session: PlayCircleOutlineIcon,
  team: GroupsOutlinedIcon,
  developer: CodeOutlinedIcon,
};

type Props = {
  open: boolean;
  tourId: TourId;
  title: string;
  body: string;
  takeTourLabel: string;
  closeLabel: string;
  onBegin: () => void;
  onDismiss: () => void;
};

/** Square's split intro: copy and CTA left, brand panel right. */
const TourIntroDialog = ({
  open,
  tourId,
  title,
  body,
  takeTourLabel,
  closeLabel,
  onBegin,
  onDismiss,
}: Props) => {
  const Illustration = ILLUSTRATION[tourId];
  return (
    <Dialog
      open={open}
      onClose={onDismiss}
      aria-labelledby="tour-intro-title"
      maxWidth="sm"
      fullWidth
      slotProps={{ paper: { sx: { borderRadius: 3, overflow: "hidden" } } }}
    >
      <Box sx={{ display: "flex", minHeight: 300 }}>
        <Box sx={{ flex: 1, p: 3, display: "flex", flexDirection: "column" }}>
          <IconButton
            aria-label={closeLabel}
            onClick={onDismiss}
            sx={{ alignSelf: "flex-start", bgcolor: "action.hover" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
          <Typography id="tour-intro-title" variant="h5" sx={{ fontWeight: 700, mt: 3 }}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
            {body}
          </Typography>
          <Box sx={{ flex: 1 }} />
          <Button
            variant="contained"
            onClick={onBegin}
            sx={{ alignSelf: "flex-end", mt: 3, textTransform: "none", fontWeight: 600 }}
            autoFocus
          >
            {takeTourLabel}
          </Button>
        </Box>
        <Box
          aria-hidden
          sx={{
            flex: 1,
            bgcolor: HOOPER_BLUE,
            color: "common.white",
            display: { xs: "none", sm: "flex" },
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Illustration sx={{ fontSize: 96 }} />
        </Box>
      </Box>
    </Dialog>
  );
};

export default TourIntroDialog;
